import axios from 'axios';

export default axios.create({
  baseURL: 'http://85.199.212.53:8000/',
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});
